/*  MUI  */
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/*  Shared  */
import { EmptyStateKpiPanel } from 'application/Shared/Components/EmptyState/EmptyStateKpiPanel';
import { CustomTooltip } from 'application/Shared/Components/Reports/CustomTooltip';
import { CustomizedDot } from 'application/Shared/Components/Reports/CustomizedDot';
import { FontSizes, QBRFIRSTREPORTS } from 'application/Shared/Constants';
import { getScoreBorderColor } from 'application/Shared/Reports/ScoreBorderColor';
import { getScoreFillColor } from 'application/Shared/Reports/ScoreFillColor';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    CartesianGrid,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from 'recharts';

/*  Constants  */
const reportName = 'SaaSSophisticationScore';

const renderLine = (params) => {
    const { reportType, theme } = params;

    let strokeWidth = 1;
    let dotOpacity = 0.1;
    let showText = false;
    let circleWidth = 4;
    let strokeColor = theme.palette.qbrFirstReports[reportType];

    // Style for SaaS Health Score
    if (reportType === reportName) {
        strokeWidth = 3;
        dotOpacity = 1;
        showText = true;
        circleWidth = 15;
        strokeColor = theme.palette.chart.saasHealthLineGraph;
    }

    return (
        <Line
            type="linear"
            key={QBRFIRSTREPORTS[reportType].name}
            dataKey={reportType}
            label={QBRFIRSTREPORTS[reportType].name}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            style={{ opacity: 1 }}
            dot={
                <CustomizedDot
                    dynamicBorderColorsFn={(value) =>
                        getScoreBorderColor({ theme, value })
                    }
                    dynamicColorsFn={(value) =>
                        getScoreFillColor({ theme, value })
                    }
                    showText={showText}
                    opacity={dotOpacity}
                    fontSize={FontSizes[1]}
                    circleWidth={circleWidth}
                />
            }
            activeDot={{ r: 8 }}
        />
    );
};

export const SaaSHealthLineGraph = ({ height: propsHeight, reportData }) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const height = propsHeight || 600;

    if (!reportData?.qbrQBRFirstSaaSSophisticationScore?.lineGraph) {
        return (
            <Box height={height} pt="64px">
                <EmptyStateKpiPanel subtitle={t('QBR.emptyHealthScoreCard')} />
            </Box>
        );
    }

    return (
        <ResponsiveContainer height={height} width="100%">
            <LineChart
                height={height}
                width={1000}
                data={reportData.qbrQBRFirstSaaSSophisticationScore.lineGraph}
                margin={{ bottom: 20, left: 10, right: 35, top: 5 }}
            >
                <CartesianGrid
                    stroke={theme.palette.chart.axis}
                    strokeDasharray="3 3"
                />
                <XAxis dataKey="day" angle={45} textAnchor="start" />
                <YAxis />
                <Tooltip
                    content={
                        <CustomTooltip
                            labelMap={QBRFIRSTREPORTS}
                            dynamicColorsFn={(value) =>
                                getScoreFillColor({ theme, value })
                            }
                            titleElement={reportName}
                        />
                    }
                />
                {Object.keys(QBRFIRSTREPORTS).map((reportType) =>
                    renderLine({ reportType, theme })
                )}
            </LineChart>
        </ResponsiveContainer>
    );
};
